<plc-box main>
	<plc-icon
		header-left
		[name]="'money-bag'"
		[size]="'l'"
		[color]="'dark-green'"
	></plc-icon>

	<plc-label
		header-center
		[title]="moneyPot().name"
		[size]="'xl'"
	></plc-label>

	<plc-label
		header-right
		[title]="'components.game.commons.money-pot-card.amount' | translate"
		>{{ moneyPot().amount }} €
	</plc-label>
	<plc-label
		header-right
		[title]="'components.game.commons.money-pot-card.increment' | translate"
	>
		{{ moneyPot().increment }} €
	</plc-label>
	<plc-box main [mainGridFlow]="'column'">
		<plc-label
			header-left
			[title]="
				'components.game.commons.money-pot-card.owners' | translate
			"
		></plc-label>
		@for (owner of owners(); track $index) {
			<main main>
				<plc-avatar
					class="plc-new-game__money-pot-avatar"
					[src]="owner.avatarUrl"
					[shape]="'square'"
				/>
				<plc-label [title]="'forms.labels.name' | translate">
					{{ owner.name }}
				</plc-label>
			</main>
		}
	</plc-box>
</plc-box>
